/**
 * React kontekst za sinhronizaciju `document.title` i vidljivog H1 naslova stranice.
 */

import React, { createContext, useContext, useState, useEffect, useRef, useCallback } from 'react';

const PageTitleContext = createContext();

/**
 * Hook za ažuriranje page title-a i H1 naslova.
 * @returns {{ pageTitle: string, h1Title: string, updateTitle: (title: string, h1?: string|null) => void, setH1Ref: (ref: HTMLElement|null) => void }}
 */
export const usePageTitle = () => {
  const context = useContext(PageTitleContext);
  if (!context) {
    throw new Error('usePageTitle must be used within PageTitleProvider');
  }
  return context;
};

/** Provider koji drži `pageTitle` / `h1Title` i sinhronizuje `document.title`. */
export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('Партнерство за отворену управу - ОГП Портал');
  const [h1Title, setH1Title] = useState('Партнерство за отворену управу');
  const h1Ref = useRef(null);

  // Ažuriraj document.title kada se pageTitle promeni
  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle;
    }
  }, [pageTitle]);

  const updateTitle = useCallback((title, h1 = null) => {
    setPageTitle(title);
    setH1Title(h1 !== null ? h1 : title);
  }, []);

  const setH1Ref = (ref) => {
    h1Ref.current = ref;
    // Ažuriraj H1 naslov odmah kada se ref postavi
    if (ref && h1Title) {
      ref.textContent = h1Title;
    }
  };

  // Ažuriraj H1 naslov kada se promeni h1Title
  useEffect(() => {
    if (h1Ref.current && h1Title) {
      h1Ref.current.textContent = h1Title;
    }
  }, [h1Title]);

  return (
    <PageTitleContext.Provider value={{ pageTitle, h1Title, updateTitle, setH1Ref }}>
      {children}
    </PageTitleContext.Provider>
  );
};

